module.exports = __webpack_public_path__ + "static/media/carrot-vs-stick-michael-whitehead.e608f3b9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/carrot-vs-stick-michael-whitehead.jpg
// module id = 944
// module chunks = 0